import { useContext } from 'react';
import ContactContext from '../context/ContactContext';

const useContact = () => useContext(ContactContext);

export default useContact;
